export default "__VITE_ASSET__1049015a__$_?nuxt_component=async__"